export default "__VITE_ASSET__B5DctJz9__"